const { BACKEND_URL, HTTP_AUTH_USER, HTTP_AUTH_PASS } = require('./constants');

export const getBackendUrl = (route) => {
  if (!BACKEND_URL) {
    return '';
  }

  const url = new URL(`${BACKEND_URL}${route}`);

  if (HTTP_AUTH_USER && HTTP_AUTH_PASS) {
    url.username = HTTP_AUTH_USER;
    url.password = HTTP_AUTH_PASS;
  }

  return url.toString();
};
